import { FC, useContext, useState } from "react";
import { DashboardContext } from "../DashboardContext";
import TeamManageCard from "./components/TeamManageCard";
import { PlatformContext } from "../../Platform/PlatformContext";
import CaptainTeamPage from "./CaptainTeamPage";

type selectedPanel = "myTeam" | "teamRequests" | "teamList";

const AdminTeamPage: FC = () => {
  const [pageState, setPageState] = useState<selectedPanel>("myTeam");
  const { requests, acceptedTeams } = useContext(DashboardContext);
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  return (
    <div
      className={`w-full max-w-screen flex flex-col items-center ${
        isMobile ? "mx-4 mt-5" : "mx-16 mt-8"
      } text-white `}
    >
      <div className="relative w-full flex  bg-white/10 rounded">
        <div
          className={`absolute top-0 left-0 h-full w-1/3 bg-white/20 rounded transition-transform duration-300 ease-in-out transform ${
            pageState === "myTeam"
              ? "translate-x-0"
              : pageState === "teamRequests"
              ? "translate-x-[100%]"
              : "translate-x-[200%]"
          }`}
        />
        <button
          className={`${
            pageState === "myTeam" ? "text-white" : "text-gray-500"
          } p-2 m-2 rounded w-full`}
          onClick={() => setPageState("myTeam")}
        >
          My Team
        </button>
        <button
          className={`${
            pageState === "teamRequests" ? "text-white" : "text-gray-500"
          } p-2 m-2 rounded w-full`}
          onClick={() => setPageState("teamRequests")}
        >
          Team Requests
        </button>
        <button
          className={`${
            pageState === "teamList" ? "text-white" : "text-gray-500"
          } p-2 m-2 rounded w-full`}
          onClick={() => setPageState("teamList")}
        >
          All Teams
        </button>
      </div>

      {pageState === "myTeam" && <CaptainTeamPage />}

      {pageState === "teamRequests" &&
        (requests.length !== 0 ? (
          <>
            <h2 className="text-2xl font-bold">Team-Requests</h2>
            <div className="w-full max-w-3xl">
              {requests
                .sort((a, b) => a.team_id - b.team_id)
                .map((request) => (
                  <TeamManageCard myTeam={request} key={request.team_id} />
                ))}
            </div>
          </>
        ) : (
          <h1 className="text-white">No pending team requests</h1>
        ))}

      {pageState === "teamList" && (
        <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full text-white overflow-y-auto mt-16">
          <div className="w-full max-w-3xl">
            {acceptedTeams
              .sort((a, b) => a.team_id - b.team_id)
              .map((accTeam) => (
                <TeamManageCard myTeam={accTeam} key={accTeam.team_id} />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminTeamPage;
